import { ResolverTag } from '@ps/web-core-enums';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { CashierFlowType } from '../../types/Cashier';

import {
  TXTWCL_For_more_help_with_depositsX_v_ELL,
  TXTWCL_For_more_help_with_transfersX__ELL,
  TXTWCL_For_more_help_with_withdrawals_ELL,
  TXTWCL_For_more_help_with_your_accoun_ELL,
  TXTWCL_Help_with_currencies,
  TXTWCL_Help_with_deposits,
  TXTWCL_Help_with_transfers,
  TXTWCL_Help_with_withdrawals,
  TXTWCL_If_you_need_help_with_your_tra_ELL,
  TXTWCL_Transactions_help
} from './helpContent.messages.json';

export const getHelpContent = (cashierFlow: CashierFlowType) => {
  const title = {
    [CashierFlowType.FirstDeposit]: TXTWCL_Help_with_deposits,
    [CashierFlowType.FirstManageCurrencies]: TXTWCL_Help_with_currencies,
    [CashierFlowType.FirstP2pTransfer]: TXTWCL_Help_with_transfers,
    [CashierFlowType.FirstTransactionHistory]: TXTWCL_Transactions_help,
    [CashierFlowType.FirstWithdraw]: TXTWCL_Help_with_withdrawals
  };
  const text = {
    [CashierFlowType.FirstDeposit]: TXTWCL_For_more_help_with_depositsX_v_ELL,
    [CashierFlowType.FirstManageCurrencies]: TXTWCL_For_more_help_with_your_accoun_ELL,
    [CashierFlowType.FirstP2pTransfer]: TXTWCL_For_more_help_with_transfersX__ELL,

    [CashierFlowType.FirstTransactionHistory]: TXTWCL_If_you_need_help_with_your_tra_ELL,
    [CashierFlowType.FirstWithdraw]: TXTWCL_For_more_help_with_withdrawals_ELL
  };
  const resolver = {
    [CashierFlowType.FirstManageCurrencies]: ResolverTag.HcCurrencyMgt,
    [CashierFlowType.FirstP2pTransfer]: ResolverTag.HelpCenterP2pTransfer
  };

  const link = (msg: string) => (
    <ResolverLink resolverTag={resolver[cashierFlow] || ResolverTag.HelpCenterDepositWithdrawal}>
      {msg}
    </ResolverLink>
  );
  return { title: title[cashierFlow], text: text[cashierFlow], link };
};
